import Modal from "../../../components/Modal/Modal";

const InfoModal = ({
  open,
  close,
  projectName,
  projectId,
  isOwner,
  shareUrl,
  leave,
  askDelete,
}) => (
  <Modal open={open} close={close} cardClassName="project-info-modal">
    <div className="project-info-head">
      <span className="project-info-kicker">Proje Detayı</span>
      <h2>{projectName}</h2>
      <div className="project-info-meta">
        <span className="project-info-pill">Aktif Proje</span>
        <span className="project-info-id">{projectId}</span>
      </div>
    </div>

    <div className="info-modal-button">
      <button className="modal-add-button" onClick={shareUrl}>
        Paylaş
      </button>
      {isOwner === false && (
        <button className="modal-close-button" onClick={leave}>
          Projeden Ayrıl
        </button>
      )}
      {isOwner === true && (
        <button className="modal-close-button" onClick={askDelete}>
          Projeyi Sil
        </button>
      )}
      <button className="modal-secondary-button" onClick={close}>
        Kapat
      </button>
    </div>
  </Modal>
);

export default InfoModal;
